export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/mathseeds-b133b10c91d6939e6aae9ef6a48ad2b9.svg";